import React, { Component } from 'react';
import { Route, Switch, Redirect, BrowserRouter } from 'react-router-dom';
import AsyncComponent from './common/js/loadAsync';
import auth from './utils/auth';
import { Toast } from 'antd-mobile';

import LiveStock from './pages/report/liveStock'; // 猪只存栏
import RealTime from './pages/report/realtime'; // 实时状态
import ParityIndex from './pages/report/parityIndex'; //  胎龄结构分析
import Loc2Index from './pages/report/loc2Index'; // 三段损失
import NonProduct from './pages/report/nonProduct'; // 脱产母猪
import Farrow19WK from './pages/report/farrow19Wk'; // 19周分娩率
import FarrowPerAnalysis from './pages/report/farrowPerAnalysis'; // 分台词产仔性能
import CostAnalysis from './pages/report/costAnalysis'; // 成本分析
import Breed from './pages/report/breed'; // 母猪配种信息
import FarrowInfo from './pages/report/farrowInfo'; // 母猪分娩信息
import WeanInfo from './pages/report/weanInfo'; // 母猪断奶信息
import Psy from './pages/report/psy'; // PSY、MSY
import Daily from './pages/report/daily'; // 日报

// 标准报表

import SwineReport from './pages/swine-report/'; // 周性能概述表
import Report01 from './pages/swine-report/report01'; // 周性能概述表
import Report02 from './pages/swine-report/report02'; // 性能分析报表
import Report03 from './pages/swine-report/report03'; // 性能分析报表
import Report04 from './pages/swine-report/report04'; // 性能分析报表
import Report05 from './pages/swine-report/report05'; // 性能分析报表
import Report06 from './pages/swine-report/report06'; // 性能分析报表
import Report07 from './pages/swine-report/report07'; // 性能分析报表
import Report08 from './pages/swine-report/report08'; // 性能分析报表
import Report09 from './pages/swine-report/report09'; // 性能分析报表
import Report11 from './pages/swine-report/report11'; // 性能分析报表
import Report12 from './pages/swine-report/report12'; // 性能分析报表
import Report13 from './pages/swine-report/report13'; // 性能分析报表
import Report14 from './pages/swine-report/report14'; // 性能分析报表
import Report15 from './pages/swine-report/report15'; // 性能分析报表
import Report16 from './pages/swine-report/report16'; // 性能分析报表

import web from './utils/native';
import loseImg from './assets/image/lose.png';

// 简版
import { FARM_ORG, ORG_CODE, TEMPVERSON } from './cache';
import CreateFarm from './pages/settings/createFarm';
import Setting from './pages/settings/';
import FarmList from './pages/settings/list/famlist';
import LocList from './pages/settings/list/loclist';
import BatchList from './pages/settings/list/batchlist';
import StaffList from './pages/settings/list/stafflist';
import ProductList from './pages/settings/list/productlist';
import SwineList from './pages/settings/list/swinelist';
import Cooperate from './pages/settings/addedit/cooperate';
import BatchEdit from './pages/settings/addedit/batchedit';
import Product from './pages/settings/addedit/product';
import SecondFarm from './pages/settings/addedit/secondFarm';
import send from './utils/send';

//  异步加载组件
const BoarMateAdd = AsyncComponent(() => import('./pages/boarmate/add')); // 配种新增(一公多母)
const BoarMateEdit = AsyncComponent(() => import('./pages/boarmate/edit')); // 配种新增(一公多母)
const BoarMateList = AsyncComponent(() => import('./pages/boarmate/index')); // 配种新增(一公多母)

const SowMateAdd = AsyncComponent(() => import('./pages/sowmate/add')); // 配种新增(一母多公)
const SowMateEdit = AsyncComponent(() => import('./pages/sowmate/edit')); // 配种编辑(一母多公)
const SowMateList = AsyncComponent(() => import('./pages/sowmate')); // 配种新增(一母多公)
//  断奶
const Wean = AsyncComponent(() => import('./pages/wean'));
const WeanAdd = AsyncComponent(() => import('./pages/wean/add'));
const WeanEdit = AsyncComponent(() => import('./pages/wean/edit'));

// 发情未配种
const HnsList = AsyncComponent(() => import('./pages/hns/index'));
const HnsDetail = AsyncComponent(() => import('./pages/hns/detail'));

// 分娩
const Farrow = AsyncComponent(() => import('./pages/farrow'));
const FarrowAdd = AsyncComponent(() => import('./pages/farrow/add'));

// 空怀返情
const NonpregnantList = AsyncComponent(() => import('./pages/nonpregnant/list'));
const NonpregnantDetail = AsyncComponent(() => import('./pages/nonpregnant/detail'));

// 肥猪死亡
const HogsDeadList = AsyncComponent(() => import('./pages/hogs-dead/index'));
const HogsDeadDetail = AsyncComponent(() => import('./pages/hogs-dead/detail'));
// 种猪死亡
const Dead = AsyncComponent(() => import('./pages/swineDead/list'));
const DeadAdd = AsyncComponent(() => import('./pages/swineDead/index'));
const DeadEdit = AsyncComponent(() => import('./pages/swineDead/edit'));

// 系谱录入
const GenealogyList = AsyncComponent(() => import('./pages/genealogy/list'));
const GenealogyAdd = AsyncComponent(() => import('./pages/genealogy/add'));
const GenealogyEdit = AsyncComponent(() => import('./pages/genealogy/edit'));

// 消耗
const ExpendDetail = AsyncComponent(() => import('./pages/expend/detail'));
const ExpendList = AsyncComponent(() => import('./pages/expend/list'));

// 猪只采购
const FatPurchaseList = AsyncComponent(() => import('./pages/fatpurchase/list'));
const FatPurchaseAdd = AsyncComponent(() => import('./pages/fatpurchase/detail'));
const FatPurchaseEdit = AsyncComponent(() => import('./pages/fatpurchase/detail'));

// 种猪采购
const BoarPurchaseList = AsyncComponent(() => import('./pages/boarpurchase/list'));
const BoarPurchaseAdd = AsyncComponent(() => import('./pages/boarpurchase/detail'));
const BoarPurchaseEdit = AsyncComponent(() => import('./pages/boarpurchase/detail'));

// 肥猪猪只转移
const SwineTranList = AsyncComponent(() => import('./pages/swineTran/index'));
const SwineTranAdd = AsyncComponent(() => import('./pages/swineTran/detail'));

const SwineMoveList = AsyncComponent(() => import('./pages/swineMove/list')); // 转移后备猪
const SwineMoveAdd = AsyncComponent(() => import('./pages/swineMove/add'));
const SwineMoveEdit = AsyncComponent(() => import('./pages/swineMove/edit'));

//  种猪销售
const SaleSwineList = AsyncComponent(() => import('./pages/sale-swine/index'));
const SaleSwineAdd = AsyncComponent(() => import('./pages/sale-swine/detail'));

// 肥猪销售
const SaleHogsList = AsyncComponent(() => import('./pages/sale-hogs/index')); // 肥猪销售
const SaleHogsAdd = AsyncComponent(() => import('./pages/sale-hogs/detail'));

// 精液，饲料，药品疫苗 销售
const SaleFeedList = AsyncComponent(() => import('./pages/sale-feed/list')); // 饲料销售、精液销售、药品销售
const SaleFeedDetail = AsyncComponent(() => import('./pages/sale-feed/detail'));

// 精液，饲料，药品疫苗 采购
const ProcurementList = AsyncComponent(() => import('./pages/procurement-drug/list')); // 药品疫苗采购
const ProcurementListDetail = AsyncComponent(() => import('./pages/procurement-drug/detail'));

const SwineTranListed = AsyncComponent(() => import('./pages/tranfer-swine/index')); // 种猪猪只转移
const SwineTranDetail = AsyncComponent(() => import('./pages/tranfer-swine/detail'));
// 饲料自动入库
const FeedAutoStorageList = AsyncComponent(() => import('./pages/feedAutoStorage/index')); // 种猪猪只转移
const FeedAutoStorage = AsyncComponent(() => import('./pages/feedAutoStorage/detail'));

// 库存盘点
const StockCheck = AsyncComponent(() => import('./pages/stock-check/index'));
const StockCheckList = AsyncComponent(() => import('./pages/stock-check/list'));

const Report = AsyncComponent(() => import('./pages/report/')); // 报表管理

const Strand = AsyncComponent(() => import('./pages/strand/')); // 报表管理详情。
const Routine = AsyncComponent(() => import('./pages/routine/'));
const RoutineAndroid = AsyncComponent(() => import('./pages/routine/indexandroid'));
const Schedule = AsyncComponent(() => import('./pages/schedule'));
const Details = AsyncComponent(() => import('./pages/schedule/details'));
const DetailsAndroid = AsyncComponent(() => import('./pages/schedule/detailsandroid'));
const WorkLog = AsyncComponent(() => import('./pages/schedule/workLog'));
const WorkLogAndroid = AsyncComponent(() => import('./pages/schedule/workLogandroid'));
const Table = AsyncComponent(() => import('./pages/TableDemo'));
const Picker = AsyncComponent(() => import('./pages/PickerDemo'));
const FemaleInfo = AsyncComponent(() => import('./pages/femaleInfo/Details'));

const CostAccount = AsyncComponent(() => import('./pages/cost/'));
const Record = AsyncComponent(() => import('./pages/cost-record/'));
const RecordAdd = AsyncComponent(() => import('./pages/cost-record/add'));
const RecordEdit = AsyncComponent(() => import('./pages/cost-record/edit'));
const Count = AsyncComponent(() => import('./pages/cost-count/'));
const CountAdd = AsyncComponent(() => import('./pages/cost-count/add'));
const CountEdit = AsyncComponent(() => import('./pages/cost-count/edit'));
// {
/*表示当前如何显示头部,0:不显示头部 1: 按照传递的metuTitle显示。 2: 表示当前是首页，由安卓控制显示什么。 */
//   showHeaderFlag: '1',
//     showBackIcon: '1', // 是否有左侧的返回关闭等。
//   menuTitle: '报表管理',
//   rightContent: ''
// }
export default class router extends Component {
  constructor(props) {
    super(props);
    this.state = {
      farm_leader_flag: '0'
    };
  }
  async componentDidMount() {
    Toast.loading('加载中', 0);
    let res = await send({
      url: '/api/ifarm/v1/user/role_check',
      method: 'GET'
    });
    if (res.status === 200) {
      let resData = res.data;
      if (resData.error !== 0) {
        // Toast.fail(resData.msg, 5);
      } else {
        const data = resData.data;
        auth.setToCookie('farm_leader_flag', data.farm_leader_flag);
        this.setState({
          farm_leader_flag: data.farm_leader_flag
        });
      }
    }
    //该农场是否合作。
    let farm = await send({
      url: '/api/ifarm/v180/farm/farm',
      method: 'GET',
      params: {
        code: FARM_ORG,
        parent_code: ORG_CODE
      }
    });
    let data = farm.data;
    if (data.statusCode === 200 && data.data) {
      auth.setToCookie('coop', data.data.cooperation === 1); // 1 合作  0 没合作
      // auth.setToCookie('farm_flag',data.data.farm_flag === 1); // 0演示农场 1非演示农场
      // auth.setToCookie('has_farm',data.data.has_farm) // 0没有其他农场  1 有其他农场
      window.$farmFlag = data.data.flag; // 5自养场 ，10客户场, 15社会场
    }
    Toast.hide(); // 这个失效了。
    document.querySelectorAll('.am-toast,.am-toast-mask').forEach((node) => {
      node.style.display = 'none';
    });
  }

  render() {
    const rightContent = this.state.farm_leader_flag === 1 ? ' ' : '新增';
    return (
      <BrowserRouter>
        <Switch>
          <Route
            exact
            path="/"
            render={() => {
              return <Redirect to="/routine" />;
            }}
          />
          <Route
            path="/workLog"
            render={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1', //  0 ： 表示不显示安卓头   1 ，表示显示安卓头 ， 2 表示显示安卓头：是菜单页，需显示农场名称
                showBackIcon: '1',
                menuTitle: '工作日志',
                rightContent: ''
              });
              return <WorkLog {...props} />;
            }}
          />
          <Route
            path="/workLogandroid"
            render={(props) => {
              TEMPVERSON.android = true;
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '2',
                showBackIcon: '',
                menuTitle: '',
                rightContent: ''
              });
              return <WorkLogAndroid {...props} />;
            }}
          />
          <Route
            path="/details"
            render={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: props.location.state.title,
                rightContent: ''
              });
              return <Details {...props} />;
            }}
          />
          <Route
            path="/detailsandroid/:symbol/:date/:gdCode/:gdType/:descLoc"
            render={(props) => {
              TEMPVERSON.android = true;
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '2',
                showBackIcon: '',
                menuTitle: '',
                rightContent: ''
              });
              return <DetailsAndroid {...props} />;
            }}
          />
          <Route
            path="/strand"
            render={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '2', // 表示当前是home页，显示农场名称
                showBackIcon: '',
                menuTitle: '报表管理',
                rightContent: ''
              });
              return <Strand {...props} />;
            }}
          />
          <Route
            path="/reportandroid"
            render={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1', // 表示当前是home页，显示农场名称
                showBackIcon: '1',
                menuTitle: '生产报表',
                rightContent: ''
              });
              return <Report {...props} />;
            }}
          />
          <Route
            path="/routine"
            render={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '2', // 表示当前是home页
                showBackIcon: '',
                menuTitle: '',
                rightContent: ''
              });
              return <Routine {...props} />;
            }}
          />
          <Route
            path="/routineandroid"
            render={(props) => {
              TEMPVERSON.android = true;
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '2', // 表示当前是home页
                showBackIcon: '',
                menuTitle: '',
                rightContent: ''
              });
              return <RoutineAndroid {...props} />;
            }}
          />
          <Route
            path="/workschedule"
            render={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '2', // 表示当前是home页
                showBackIcon: '',
                menuTitle: '',
                rightContent: ''
              });
              return <Schedule {...props} />;
            }}
          />
          {/** 发情未配种 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '发情未配种列表',
                rightContent
              });
              return <HnsList {...props} />;
            }}
            path="/hns_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增发情未配种',
                rightContent: '列表'
              });
              return <HnsDetail {...props} />;
            }}
            path="/hns_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑发情未配种',
                rightContent: '列表'
              });
              return <HnsDetail {...props} />;
            }}
            path="/hns_edit"
          />
          {/** 配种(一公多母) */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增记录配种',
                rightContent: '列表'
              });
              return <BoarMateAdd {...props} />;
            }}
            path="/boarmate_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑记录配种',
                rightContent: '列表'
              });
              return <BoarMateEdit {...props} />;
            }}
            path="/boarmate_edit"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '配种列表(多母)',
                rightContent
              });
              return <BoarMateList {...props} />;
            }}
            path="/boarmate_list"
          />
          {/** 配种(一母多公) */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '配种信息(多公) ',
                rightContent: '列表'
              });
              return <SowMateAdd {...props} />;
            }}
            path="/sowmate_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑配种(多公)',
                rightContent: '列表'
              });
              return <SowMateEdit {...props} />;
            }}
            path="/sowmate_edit"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '配种(多公)',
                rightContent
              });
              return <SowMateList {...props} />;
            }}
            path="/sowmate_list"
          />
          {/** 空怀返情 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '流产返情空怀列表',
                rightContent
              });
              return <NonpregnantList {...props} />;
            }}
            path="/nonpregnant_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增流产返情空怀',
                rightContent: '列表'
              });
              return <NonpregnantDetail {...props} />;
            }}
            path="/nonpregnant_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑流产返情空怀',
                rightContent: '列表'
              });
              return <NonpregnantDetail {...props} />;
            }}
            path="/nonpregnant_edit"
          />
          {/** 分娩信息 */}
          <Route
            path="/farrow_list"
            render={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '分娩信息',
                rightContent
              });
              return <Farrow {...props} />;
            }}
          />
          <Route
            path="/farrow_add"
            render={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增分娩',
                rightContent: '列表'
              });
              return <FarrowAdd {...props} />;
            }}
          />
          <Route
            path="/farrow_edit"
            render={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑分娩',
                rightContent: '列表'
              });
              return <FarrowAdd {...props} />;
            }}
          />
          {/** 断奶 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '断奶列表',
                rightContent
              });
              return <Wean {...props} />;
            }}
            path="/wean_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增断奶',
                rightContent: '列表'
              });
              return <WeanAdd {...props} />;
            }}
            path="/wean_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑断奶',
                rightContent: '列表'
              });
              return <WeanEdit {...props} />;
            }}
            path="/wean_edit"
          />
          {/** 肥猪转移 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '猪只转移列表',
                rightContent
              });
              return <SwineTranList {...props} />;
            }}
            path="/swine_tranfer_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增猪只转移',
                rightContent: '列表'
              });
              return <SwineTranAdd {...props} />;
            }}
            path="/swine_tranfer_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑猪只转移',
                rightContent: '列表'
              });
              return <SwineTranAdd {...props} />;
            }}
            path="/swine_tranfer_edit"
          />
          {/** 转移后备 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '转移后备列表',
                rightContent
              });
              return <SwineMoveList {...props} />;
            }}
            path="/swine_move_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增转移后备',
                rightContent: '列表'
              });
              return <SwineMoveAdd {...props} />;
            }}
            path="/swine_move_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑转移后备',
                rightContent: '列表'
              });
              return <SwineMoveEdit {...props} />;
            }}
            path="/swine_move_edit"
          />
          {/** 系谱录入 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '系谱录入列表',
                rightContent
              });
              return <GenealogyList {...props} />;
            }}
            path="/genealogy_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增系谱录入',
                rightContent: '列表'
              });
              return <GenealogyAdd {...props} />;
            }}
            path="/genealogy_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑系谱录入',
                rightContent: '列表'
              });
              return <GenealogyEdit {...props} />;
            }}
            path="/genealogy_edit"
          />

          {/** 种猪死亡 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '种猪死亡列表',
                rightContent
              });
              return <Dead {...props} />;
            }}
            path="/swine_dead_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增种猪死亡',
                rightContent: '列表'
              });
              return <DeadAdd {...props} />;
            }}
            path="/swine_dead_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑种猪死亡',
                rightContent: '列表'
              });
              return <DeadEdit {...props} />;
            }}
            path="/swine_dead_edit"
          />
          {/** 种猪销售 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '种猪销售',
                rightContent
              });
              return <SaleSwineList {...props} />;
            }}
            path="/sale_swine_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增种猪销售',
                rightContent: '列表'
              });
              return <SaleSwineAdd {...props} />;
            }}
            path="/sale_swine_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑种猪销售',
                rightContent: '列表'
              });
              return <SaleSwineAdd {...props} />;
            }}
            path="/sale_swine_edit"
          />
          {/* 种猪采购 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增种猪采购',
                rightContent: '列表'
              });
              return <BoarPurchaseAdd {...props} />;
            }}
            path="/boar_purchase_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑种猪采购',
                rightContent: '列表'
              });
              return <BoarPurchaseEdit {...props} />;
            }}
            path="/boar_purchase_edit"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '种猪采购列表',
                rightContent
              });
              return <BoarPurchaseList {...props} />;
            }}
            path="/boar_purchase_list"
          />
          {/**-------------------------------*/}
          {/* 种猪猪只转移 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '种猪转移列表',
                rightContent
              });
              return <SwineTranListed {...props} />;
            }}
            path="/hogs_trans_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增种猪转移',
                rightContent: '列表'
              });
              return <SwineTranDetail {...props} />;
            }}
            path="/hogs_trans_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑种猪转移',
                rightContent: '列表'
              });
              return <SwineTranDetail {...props} />;
            }}
            path="/hogs_trans_edit"
          />
          {/* 肥猪死亡 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '死亡列表',
                rightContent
              });
              return <HogsDeadList {...props} />;
            }}
            path="/hogs_dead_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增死亡信息',
                rightContent: '列表'
              });
              return <HogsDeadDetail {...props} />;
            }}
            path="/hogs_dead_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑死亡信息',
                rightContent: '列表'
              });
              return <HogsDeadDetail {...props} />;
            }}
            path="/hogs_dead_edit"
          />
          {/* 肥猪销售 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '肥猪销售列表',
                rightContent
              });
              return <SaleHogsList {...props} />;
            }}
            path="/hogs_sale_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增肥猪销售',
                rightContent: '列表'
              });
              return <SaleHogsAdd {...props} />;
            }}
            path="/hogs_sale_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑肥猪销售',
                rightContent: '列表'
              });
              return <SaleHogsAdd {...props} />;
            }}
            path="/hogs_sale_edit"
          />
          {/* 猪只采购 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '猪只采购列表',
                rightContent
              });
              return <FatPurchaseList {...props} />;
            }}
            path="/hogs_purchase_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增猪只采购',
                rightContent: '列表'
              });
              return <FatPurchaseAdd {...props} />;
            }}
            path="/hogs_purchase_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑猪只采购',
                rightContent: '列表'
              });
              return <FatPurchaseEdit {...props} />;
            }}
            path="/hogs_purchase_edit"
          />
          {/** 精液消耗 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '精液耗用列表',
                rightContent
              });
              return <ExpendList {...props} />;
            }}
            path="/expend_semen_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增精液耗用',
                rightContent: '列表'
              });
              return <ExpendDetail {...props} />;
            }}
            path="/expend_semen_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑精液耗用',
                rightContent: '列表'
              });
              return <ExpendDetail {...props} />;
            }}
            path="/expend_semen_edit"
          />

          {/** 消耗: 饲料 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '饲料耗用列表',
                rightContent
              });
              return <ExpendList {...props} />;
            }}
            path="/expend_feed_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增饲料耗用',
                rightContent: '列表'
              });
              return <ExpendDetail {...props} />;
            }}
            path="/expend_feed_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑饲料耗用',
                rightContent: '列表'
              });
              return <ExpendDetail {...props} />;
            }}
            path="/expend_feed_edit"
          />
          {/* 消耗药品*/}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '药品疫苗耗用列表',
                rightContent
              });
              return <ExpendList {...props} />;
            }}
            path="/expend_drug_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增药品疫苗耗用',
                rightContent: '列表'
              });
              return <ExpendDetail {...props} />;
            }}
            path="/expend_drug_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑药品疫苗耗用',
                rightContent: '列表'
              });
              return <ExpendDetail {...props} />;
            }}
            path="/expend_drug_edit"
          />
          {/* 精液销售 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '精液销售列表',
                rightContent
              });
              return <SaleFeedList {...props} />;
            }}
            path="/sale_semen_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增精液销售',
                rightContent: '列表'
              });
              return <SaleFeedDetail {...props} />;
            }}
            path="/sale_semen_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑精液销售',
                rightContent: '列表'
              });
              return <SaleFeedDetail {...props} />;
            }}
            path="/sale_semen_edit"
          />
          {/* 饲料销售 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '饲料销售列表',
                rightContent
              });
              return <SaleFeedList {...props} />;
            }}
            path="/sale_feed_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增饲料销售',
                rightContent: '列表'
              });
              return <SaleFeedDetail {...props} />;
            }}
            path="/sale_feed_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑饲料销售',
                rightContent: '列表'
              });
              return <SaleFeedDetail {...props} />;
            }}
            path="/sale_feed_edit"
          />
          {/* 药品销售 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '药品销售列表',
                rightContent
              });
              return <SaleFeedList {...props} />;
            }}
            path="/sale_drug_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增药品销售',
                rightContent: '列表'
              });
              return <SaleFeedDetail {...props} />;
            }}
            path="/sale_drug_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑药品销售',
                rightContent: '列表'
              });
              return <SaleFeedDetail {...props} />;
            }}
            path="/sale_drug_edit"
          />
          {/* 精液采购 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '精液采购列表',
                rightContent
              });
              let info = {
                model: 'semen'
              };
              return <ProcurementList {...props} {...info} />;
            }}
            path="/procurement_semen_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增精液采购',
                rightContent: '列表'
              });
              return <ProcurementListDetail {...props} />;
            }}
            path="/procurement_semen_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑精液采购',
                rightContent: '列表'
              });
              return <ProcurementListDetail {...props} />;
            }}
            path="/procurement_semen_edit"
          />
          {/* 饲料采购 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '饲料采购列表',
                rightContent
              });
              return <ProcurementList {...props} />;
            }}
            path="/procurement_feed_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增饲料采购',
                rightContent: '列表'
              });
              return <ProcurementListDetail {...props} />;
            }}
            path="/procurement_feed_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑饲料采购',
                rightContent: '列表'
              });
              return <ProcurementListDetail {...props} />;
            }}
            path="/procurement_feed_edit"
          />
          {/* 药品采购 */}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '药品采购列表',
                rightContent
              });
              return <ProcurementList {...props} />;
            }}
            path="/procurement_drug_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增药品采购',
                rightContent: '列表'
              });
              return <ProcurementListDetail {...props} />;
            }}
            path="/procurement_drug_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑药品采购',
                rightContent: '列表'
              });
              return <ProcurementListDetail {...props} />;
            }}
            path="/procurement_drug_edit"
          />
          {/* 生产精液*/}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '生产精液列表',
                rightContent
              });
              return <ExpendList {...props} />;
            }}
            path="/produce_semen_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增生产精液',
                rightContent: '列表'
              });
              return <ExpendDetail {...props} />;
            }}
            path="/produce_semen_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑生产精液',
                rightContent: '列表'
              });
              return <ExpendDetail {...props} />;
            }}
            path="/produce_semen_edit"
          />
          {/*饲料自动入库*/}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '饲料自动入库列表',
                rightContent: ''
              });
              return <FeedAutoStorageList {...props} />;
            }}
            path="/feed_autostorage_list"
          />
          <Route
            component={(props) => {
              console.log(props);

              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增饲料自动入库',
                rightContent: '列表'
              });
              return <FeedAutoStorage {...props} />;
            }}
            path="/feed_autostorage_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑饲料自动入库',
                rightContent: '列表'
              });
              return <FeedAutoStorage {...props} />;
            }}
            path="/feed_autostorage_edit"
          />
          {/*饲料安卓的自动入库*/}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '2',
                showBackIcon: '1',
                menuTitle: '饲料自动入库列表',
                rightContent: ''
              });
              return <FeedAutoStorageList {...props} />;
            }}
            path="/feed_autostorageAndroid_list"
          />
          <Route
            component={(props) => {
              console.log(props);

              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '新增饲料自动入库',
                rightContent: '列表'
              });
              return <FeedAutoStorage {...props} />;
            }}
            path="/feed_autostorageAndroid_add"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '编辑饲料自动入库',
                rightContent: '列表'
              });
              return <FeedAutoStorage {...props} />;
            }}
            path="/feed_autostorageAndroid_edit"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '盘点库存',
                rightContent: ''
              });
              return <StockCheck {...props} />;
            }}
            path="/stock_check_edit"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '2',
                showBackIcon: '1',
                menuTitle: '盘点库存列表',
                rightContent: ''
              });
              return <StockCheckList {...props} />;
            }}
            path="/stock_check_list"
          />
          {/*报表模块*/}

          {/*报表开始*/}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '猪只存栏信息',
                rightContent: ''
              });
              return <LiveStock {...props} />;
            }}
            path="/livestock"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '母猪实时状态',
                rightContent: ''
              });
              return <RealTime {...props} />;
            }}
            path="/realtime"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '母猪胎龄结构',
                rightContent: ''
              });
              return <ParityIndex {...props} />;
            }}
            path="/parityindex"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '成本分析',
                rightContent: ''
              });
              return <CostAnalysis {...props} />;
            }}
            path="/costanalysis"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '母猪配种信息',
                rightContent: ''
              });
              return <Breed {...props} />;
            }}
            path="/breed"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '母猪分娩信息',
                rightContent: ''
              });
              return <FarrowInfo {...props} />;
            }}
            path="/farrowinfo"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '母猪断奶信息',
                rightContent: ''
              });
              return <WeanInfo {...props} />;
            }}
            path="/weaninfo"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: 'PSY、MSY',
                rightContent: ''
              });
              return <Psy {...props} />;
            }}
            path="/psy"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '日报',
                rightContent: ''
              });
              return <Daily {...props} />;
            }}
            path="/daily"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '三段损失分析',
                rightContent: ''
              });
              return <Loc2Index {...props} />;
            }}
            path="/loc2index"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '',
                rightContent: '列表'
              });
              return <Picker {...props} />;
            }}
            path="/picker"
          />
          <Route
            path="/femaleinfo/inner/:swineTrack/:swineDateIn"
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '母猪个体信息',
                rightContent: ''
              });
              return <FemaleInfo {...props} />;
            }}
          />

          <Route
            path="/femaleinfo/:swineTrack/:swineDateIn"
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '2',
                showBackIcon: '2',
                menuTitle: '母猪个体信息',
                rightContent: ''
              });
              return <FemaleInfo {...props} />;
            }}
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '脱产母猪分析',
                rightContent: ''
              });
              return <NonProduct {...props} />;
            }}
            path="/nonproduct"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '19周分娩率',
                rightContent: ''
              });
              return <Farrow19WK {...props} />;
            }}
            path="/farrow19wk"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '产仔性能分析',
                rightContent: ''
              });
              return <FarrowPerAnalysis {...props} />;
            }}
            path="/farrowperanalysis"
          />

          {/*标准报表： 种猪报表*/}
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '种猪报表',
                rightContent: ''
              });
              return <SwineReport {...props} />;
            }}
            path="/swineReport"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '周性能概述表',
                rightContent: ''
              });
              return <Report01 {...props} />;
            }}
            path="/swine_report01"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '性能分析报表',
                rightContent: ''
              });
              return <Report02 {...props} />;
            }}
            path="/swine_report02"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '0胎母猪性能分析',
                rightContent: ''
              });
              return <Report03 {...props} />;
            }}
            path="/swine_report03"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '分娩分析',
                rightContent: ''
              });
              return <Report04 {...props} />;
            }}
            path="/swine_report04"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '分娩分析(未怀孕原因)',
                rightContent: ''
              });
              return <Report05 {...props} />;
            }}
            path="/swine_report05"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '重配天数分布图',
                rightContent: ''
              });
              return <Report06 {...props} />;
            }}
            path="/swine_report06"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '性能分析报表（按胎次分）',
                rightContent: ''
              });
              return <Report07 {...props} />;
            }}
            path="/swine_report07"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '技术人员生产数据统计表',
                rightContent: ''
              });
              return <Report08 {...props} />;
            }}
            path="/swine_report08"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '发情至第一次配种天数分布图',
                rightContent: ''
              });
              return <Report09 {...props} />;
            }}
            path="/swine_report09"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '淘汰母猪分析表',
                rightContent: ''
              });
              return <Report11 {...props} />;
            }}
            path="/swine_report11"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '淘汰母猪胎次分布图',
                rightContent: ''
              });
              return <Report12 {...props} />;
            }}
            path="/swine_report12"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '胎次结构分布图',
                rightContent: ''
              });
              return <Report13 {...props} />;
            }}
            path="/swine_report13"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '配种预警',
                rightContent: ''
              });
              return <Report14 {...props} />;
            }}
            path="/swine_report14"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '分娩预警',
                rightContent: ''
              });
              return <Report15 {...props} />;
            }}
            path="/swine_report15"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '断奶预警',
                rightContent: ''
              });
              return <Report16 {...props} />;
            }}
            path="/swine_report16"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '申请合作猪场',
                rightContent: ''
              });
              return <SecondFarm {...props} />;
            }}
            path="/secondfarm"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              const pathname = props.location.pathname;
              const menus = {
                '/createfarm/farm_add': '创建农场',
                '/createfarm/loc_add': '创建栋舍',
                '/createfarm/batch_add': '批次维护',
                '/createfarm/staff_add': '员工管理',
                '/createfarm/product_add': '商品期初',
                '/createfarm/swine_add': '猪只管理'
              };
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '',
                menuTitle: menus[pathname],
                rightContent: ''
              });
              return <CreateFarm {...props} />;
            }}
            path="/createfarm"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '期初',
                rightContent: ''
              });
              return <Product {...props} />;
            }}
            path="/create_product"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '猪场设定',
                rightContent: ''
              });
              return <Setting {...props} />;
            }}
            path="/setting"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '农场管理',
                rightContent: ''
              });
              return <FarmList {...props} />;
            }}
            path="/farm_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '栋舍管理',
                rightContent: ''
              });
              return <LocList {...props} />;
            }}
            path="/loc_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '批次管理',
                rightContent: ''
              });
              return <BatchList {...props} />;
            }}
            path="/batch_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '批次管理',
                rightContent: ''
              });
              return <BatchList {...props} />;
            }}
            path="/batch_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '创建批次',
                rightContent: ''
              });
              return <BatchEdit {...props} />;
            }}
            path="/batch_edit"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '员工管理',
                rightContent: ''
              });
              return <StaffList {...props} />;
            }}
            path="/staff_list/:isFirst"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '员工管理',
                rightContent: ''
              });
              return <StaffList {...props} />;
            }}
            path="/staff_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '商品管理',
                rightContent: ''
              });
              return <ProductList {...props} />;
            }}
            path="/product_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '猪只管理',
                rightContent: ''
              });
              return <SwineList {...props} />;
            }}
            path="/swine_list"
          />
          <Route
            component={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1',
                showBackIcon: '1',
                menuTitle: '申请合作',
                rightContent: ''
              });
              return <Cooperate {...props} />;
            }}
            path="/cooperate"
          />
          {/*成本控制*/}
          <Route
            path="/costaccount"
            render={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '2', // 表示当前是home页，显示农场名称
                showBackIcon: '',
                menuTitle: '成本核算',
                rightContent: ''
              });
              return <CostAccount {...props} />;
            }}
          />
          <Route
            path="/record_list"
            render={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1', // 表示当前是home页，显示农场名称
                showBackIcon: '1',
                menuTitle: '记一笔',
                rightContent: '新增'
              });
              return <Record {...props} />;
            }}
          />
          <Route
            path="/record_add"
            render={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1', // 表示当前是home页，显示农场名称
                showBackIcon: '1',
                menuTitle: '新增费用',
                rightContent: '列表'
              });
              return <RecordAdd {...props} />;
            }}
          />
          <Route
            path="/record_edit"
            render={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1', // 表示当前是home页，显示农场名称
                showBackIcon: '1',
                menuTitle: '编辑费用',
                rightContent: '列表'
              });
              return <RecordEdit {...props} />;
            }}
          />
          <Route
            path="/count_add"
            render={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1', // 表示当前是home页，显示农场名称
                showBackIcon: '1',
                menuTitle: '当期成本',
                rightContent: ''
              });
              return <CountAdd {...props} />;
            }}
          />
          <Route
            path="/count_list"
            render={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1', // 表示当前是home页，显示农场名称
                showBackIcon: '1',
                menuTitle: '算一算',
                rightContent: ''
              });
              return <Count {...props} />;
            }}
          />
          <Route
            path="/count_edit"
            render={(props) => {
              web.initWebGo(props);
              web.sendToNative({
                showHeaderFlag: '1', // 表示当前是home页，显示农场名称
                showBackIcon: '1',
                menuTitle: '解锁',
                rightContent: ''
              });
              return <CountEdit {...props} />;
            }}
          />
          {/*出错的页面去这里*/}
          <Route
            render={() => (
              <div>
                <div style={{ marginTop: '80px', textAlign: 'center' }}>
                  <img alt="" height="240" src={loseImg} width="221" />
                </div>
                <div style={{ textAlign: 'center' }}>
                  <span
                    style={{
                      fontSize: '18px',
                      lineHeight: 2,
                      color: '#000'
                    }}
                  >
                    页面不见了，请联系管理员 ！！！
                  </span>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <span style={{ fontSize: '14px', color: '#ccc', lineHeight: 2 }}>
                    详细信息:（
                    {window.location.href}）
                  </span>
                </div>
              </div>
            )}
          />
        </Switch>
      </BrowserRouter>
    );
  }
}
